'use client';
import { Button, useDisclosure } from '@heroui/react';
import Image from 'next/image';
import React from 'react';
import { useIsMobile } from '@/app/hooks/use-is-mobile';
import useOfferComparisonStore from '../store/use-offer-comparison-store';
import ModalTemplate from './modal-template';
import { useTranslations } from 'next-intl';
import ShareModalContent from './share-modal-content';
import StartBookingButton from './start-booking-button';

export default function StickyBanner() {
  const offer = useOfferComparisonStore((state) => state.offer);
  const isMobile = useIsMobile();
  const { onOpen, isOpen, onOpenChange } = useDisclosure();
  const t = useTranslations('shareOffer');

  if (!offer) {
    return;
  }
  return (
    <div className="sticky bottom-0 bg-[var(--color-card-primary)] min-h-[74px] md:min-h-[98px] content-center font-semibold md:border-t md:border-[var(--color-border-default)]">
      <div className="flex flex-row gap-x-3 content-center justify-center md:justify-end w-full max-w-[1015px] mx-auto md:pr-4">
        <Button
          data-testid="share-button"
          className="!inline-flex btn-secondary btn-padded border-transparent md:border-black"
          onPress={onOpen}
          endContent={
            isMobile && (
              <Image
                src="/images/share-icon.svg"
                alt="share icon"
                width={20}
                height={15.75}
              />
            )
          }
        >
          {isMobile ? t('share') : t('shareOffer')}
        </Button>
        <ModalTemplate
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          title={t('title')}
        >
          <ShareModalContent />
        </ModalTemplate>
        <div data-testid="stickyBannerBookButton">
          <StartBookingButton testId="stickyBannerStartBookingButton" />
        </div>
      </div>
    </div>
  );
}
